import type { MailboxInfo } from 'owa-client-types';
import type { AcquisitionCategoryEncoding, PlatformType, StrictTitle } from '../types';
import { EPOCH_TIME } from './constants/constants';
import { EMPTY_COPILOT_CAPABILITIES } from './constants/emptyCapability';
import { EMPTY_ELIGIBILITY } from './constants/emptyEligibility';

type TitleCreation = {
    id: string;
    nameResolver: (mailboxInfo?: MailboxInfo) => string;
    icons: {
        normalIcon: string;
        outlineIcon: string;
    };
    platformType: PlatformType;
};

const PRIMARY_COLOR = '#0078D4';

export function createNativeTitle(
    creationArgs: TitleCreation,
    mailboxInfo?: MailboxInfo
): StrictTitle {
    const { id, nameResolver, icons, platformType } = creationArgs;
    const categories: AcquisitionCategoryEncoding[] = [platformType];

    const resolvedName = nameResolver(mailboxInfo);
    return {
        __typename: 'Title',
        // Encoded values for tiling: Direct mapping
        ingestionId: id,
        name: resolvedName,
        acquisitionDate: EPOCH_TIME,
        // Encoded values for tiling: Indirect mapping
        categories,
        longDescription: resolvedName,
        shortDescription: resolvedName,
        iconSmall: {
            __typename: 'M365AcquisitionIcon',
            uri: icons.normalIcon,
        },
        iconLarge: {
            __typename: 'M365AcquisitionIcon',
            uri: icons.normalIcon,
        },
        iconOutline: {
            __typename: 'M365AcquisitionIcon',
            uri: icons.outlineIcon,
        },
        colorIconSmall: {
            __typename: 'M365AcquisitionIcon',
            uri: icons.normalIcon,
        },
        elementDefinitions: {
            __typename: 'ElementDefinition',
            composeExtensions: [],
            exchangeAddIns: [],
            extensions: [],
            declarativeCopilots: [],
            customEngineCopilots: [],
            staticTabs: [
                {
                    __typename: 'LaunchPage',
                    entityId: id,
                    name: resolvedName,
                    contentUrl: 'https://example.org/',
                    websiteUrl: '',
                    scopes: ['personal'],
                },
            ],
        },
        // Default contextual values
        accentColor: PRIMARY_COLOR,
        // Default static values
        isFullScreen: false,
        isFullTrust: false,
        developerName: 'Microsoft Corporation',
        developerUrl: 'https://www.microsoft.com/',
        termsOfUseUrl: 'https://www.microsoft.com/servicesagreement',
        permissions: [],
        devicePermissions: [],
        validDomains: [],
        showLoadingIndicator: true,
        blockStatus: false,
        ingestionSource: 'Hardcoded',
        scope: 'Tenant',
        webApplicationInfo: {
            __typename: 'WebApplicationInfo',
            id: '',
            resource: '',
        },
        version: '0.0.0', // NA
        cultureName: 'en-US',
        manifestVersion: '1.13',
        authorization: {
            __typename: 'AppAuthorization',
            permissions: {
                __typename: 'AppPermissions',
                orgWide: [],
                resourceSpecific: [],
            },
        },
        copilotEnabled: false,
        copilotSettings: {
            __typename: 'CopilotSettings',
            displayName: '',
            elementType: 'Extension',
            capabilities: EMPTY_COPILOT_CAPABILITIES,
        },
        eligibility: EMPTY_ELIGIBILITY,
    };
}
